<template>
  <HeaderComp/>
  <div class="container">

    <div class="reglas">
    <h2>FAQS</h2>
    <h3>Plataforma</h3>
    <p>Este torneio SÓ SERÁ JOGADO NO PS4</p>

    <h3>Manual para criação de partida e convite do rival:</h3>
    <p>
      1. Acede ao canal correspondente no <a href="https://discord.gg/FEJmJM3Wxf" class="bracket-link" target="_blank">Discord</a> (Partida "ID")
      <br>
      2. Adiciona o teu rival como amigo na PlayStation.
      <br>
      3. Dentro do jogo, vai ao menu "Amigáveis" na seção FIFA Ultimate Team.
      <br>
      4. Escolhe o modo Classic Match
      <br>
      5. Convida o teu rival da tua lista de amigos
      <br>
      6. Configura o jogo.
      <br>
      7. Inicia o jogo.
    </p>

    <h3> Configurações do jogo</h3>
    <p>
      Modo de jogo: FIFA Ultimate Team.
      <br>
      Duração: 6 minutos por metade.
      <br>
      Velocidade do jogo: Normal.
      <br>
      Nível de dificuldade: Lendário.
      <br>
      Tipo de partida: FUT Classic.
      <br>
      O jogador do lado esquerdo/superior da folha de chaves será o único a criar a partida e depois convidar seu oponente.
    </p>

    <h3>Configuração e Requisitos do Esquadrão do FUT</h3>
    <p>
    · Número médio de jogadores permitidos: 79 a 89.<br>
    · Itens de jogador com média de 90 ou mais permitidos: 1.<br>
    · Itens especiais de jogador permitidos: 2.<br>
    · Jogadores emprestados permitidos: 1.<br>
    · Uniformes e emblemas permitidos: Todos os uniformes e emblemas são permitidos. (edited)
    </p>
    <p>
    A configuração aqui descrita engloba os jogadores titulares e substitutos, por exemplo. Só pode ter um item de jogador com média igual ou superior a 90 entre os 18 jogadores do seu plantel (11 titulares e 7 suplentes), ou seja, não pode ter um item de jogador com média igual ou superior a 90 entre os titulares e um mais um entre suplentes. O mesmo exemplo se aplica aos outros requisitos.
    </p>
    <p>
      <b> Itens de jogador especial: </b> significa qualquer item de jogador que não seja de qualidade ouro, isso significa que seu esquadrão terá que ter no mínimo 16 itens de jogador de ouro e 2 itens de jogador de qualquer outro tipo, desde que atendam aos requisitos de jogador e média de esquadrão.
    </p>

    <h3>Nome do elenco do FIFA Ultimate Team</h3>
    <p>
    O nome do seu modelo FIFA Ultimate Team deve ser o mesmo do seu usuário PlayStation para que a equipe de arbitragem possa associar suas imagens de teste a você e assim confirmar que os resultados são válidos.
    </p>

    <h3>Configuração do controlador FUT</h3>
    <p>
      A configuração do controle deve ser em modo competitivo e com a seguinte configuração:
      <br>
      Mudança geral competitiva: Ativado.
      <br>
      Drible ágil contextual: desativado.
      <br>
      Liberações automáticas: Desligado.
      <br>
      Auto Smart Pass: Desligado.
      <br>
      Disparos automáticos: Desligado.
      <br>
      Cabeçadas assistidas: Desligado.
      <br>
      Frente: Manual.
    </p>

    <h3>Partida empatada</h3>
    <p>
      Caso os dois primeiros tempos (90 minutos de jogo) terminem empatados, o jogo deve ser reiniciado na prorrogação, se o empate persistir no final da prorrogação, o vencedor será decidido em uma série de pênaltis.
    </p>

      <h3>Restrições de itens do jogo</h3>
    <p>
      Restrições podem ser adicionadas a qualquer momento antes ou durante uma série se forem encontrados bugs conhecidos em qualquer elemento do jogo. O fato de ignorar essas restrições, de forma deliberada ou intencional, pode ser motivo de derrota e expulsão do jogador da competição.
    </p>


      <h3>Pausas</h3>
    <p>
      As pausas só podem ser feitas durante um dos seguintes lances de bola parada: tiro de saída, tiro de saída, tiro de meta, reposição, tiro de canto, tiro livre ou tiro penal. No caso de fazer uma pausa enquanto a bola está em jogo, a equipa de arbitragem analisará a situação do jogo, se a pausa afetar o resultado ou a continuidade do jogo, a equipa de arbitragem pode atribuir a derrota total do jogo ao jogador a seu critério. a pausa. Como limite, cada jogador terá 3 pausas.
    </p>

      <h3>Resultados</h3>
    <p>
      Ao final de cada partida, os jogadores são responsáveis por capturar a tela de resultados e reportá-la na planilha de chaves clicando no botão reportar resultado onde será permitido o upload da imagem. Caso o tempo de apresentação do resultado seja ultrapassado, a administração deve ser notificada através do suporte.
    </p>

    <h3>Desconexões e remakes</h3>
    <p>
      Desconexão. Os participantes não podem causar uma desconexão intencional durante um jogo. Fazer isso significa desqualificação total do torneio. Se um jogador perder a conexão sem querer, ele perderá automaticamente o jogo atual, mas poderá jogar os jogos subsequentes da mesma série.
    </p>

    <h3>Remakes</h3>
    <p>
      Os Árbitros podem considerar um remake, a seu exclusivo critério, se houver uma falha no servidor do jogo e todos os jogadores não conseguirem se conectar.
      ping alto. Os jogadores são os únicos responsáveis pela qualidade de sua conexão com a internet e entre jogadores. Os jogadores não podem solicitar uma pausa ou refazer devido a ping alto ou más condições de rede.
    </p>

    <h3>Incompatibilidade de conexão</h3>
    <p>
      Há casos em que os Jogadores não conseguem se conectar entre si devido à incompatibilidade entre seus provedores de internet, caso isso aconteça, o jogo será cancelado e nenhum dos Jogadores avançará para a próxima rodada, pois não é possível determinar a um vencedor.
    </p>

      <div class="buttons">
        <a href="https://discord.gg/FEJmJM3Wxf" class="bracket-link" target="_blank"><button>Apoio</button></a>
      </div>

      </div>
      <FooterComp/>
    </div>

</template>

<script>
import HeaderComp from "../components/Header.vue";
import FooterComp from "@/components/Footer.vue";

export default {
  data(){
    return{
      tournament:'TOURNAMENT',
    }
  },
  components: { HeaderComp, FooterComp }
}
</script>
<style lang="scss" scoped>
.container{
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 50px;
  .reglas {
    text-align: center;
    width: 60%;
  }
  @media (max-width: 768px) {
    .reglas {
      width: 100%;
    }
  }
  .logo{
    width: 150px;
    margin-bottom: 35px;
  }
  h2{
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;
    text-align: center;
    color: #012A2D;
    margin-bottom: 35px;
  }
  p{
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    color: #000000;
    margin-bottom: 35px;

  }
  button{
    width: 308px;
    height: 44px;
    background: #17E88F;
    border: none;
    transition: all .2s;
    cursor: pointer;
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;
    color: #012A2D;
    margin-bottom: 40px;
    @media only screen and (max-width:740px){
      width: 270px;
    }
    &:active{
      transform: scale(0.95);
    }
    &:hover{
      box-shadow: 0 0 10px 10px rgba(0, 0, 0, 0.05);
    }
  }
  .footer{
    width: 100%;
  }
  .bg-hexa{
    position: absolute;
    left: 0;
    bottom: 300px;
    z-index: -1;
    width: 430px;
    @media only screen and (max-width:1140px){
      width: 250px;
      bottom: 200px;
    }
    @media only screen and (max-width:740px){
      width: 180px;
      bottom: 150px;
    }
  }
}

</style>